export default {
  methods: {
    $thousandMask(number, scale) {
      return this.addCommas(number, scale);
    },
    addCommas(nStr, scale = -1) {
      if (scale > -1) {
        let number = nStr;
        if (nStr.toString().includes("e")) {
          number = parseFloat(nStr).toFixed(scale);
        } else {
          number =
            number && number.toString().split(".")[1]
              ? this.checkDecimalLength(number, scale)
              : number;
        }
        let x = number.toString().split(".");
        let x1 = x[0];
        let x2 = x.length > 1 ? "." + x[1] : "";
        let rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, "$1" + "," + "$2");
        }
        return x1 + x2;
      } else {
        nStr += "";
        let x = nStr.split(".");
        let x1 = x[0];
        let x2 = x.length > 1 ? "." + x[1] : "";
        let rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, "$1" + "," + "$2");
        }
        return `${x1}${x2}`;
      }
    },
    validateInteger(int) {
      const str = int.toString();
      return str[1] ? (str[0] === "0" && str[1] !== "." ? "" : str) : str;
    },
    checkDecimalLength(number, scale) {
      let floatingNumber = number.toString().split(".")[1];
      let floatingNumberLength = number.toString().split(".")[1].length;
      let integerNumber = this.validateInteger(number.toString().split(".")[0]);
      floatingNumber =
        floatingNumberLength > scale
          ? floatingNumber.slice(0, scale)
          : floatingNumber;
      if (scale >= 1 || (scale === undefined && floatingNumberLength))
        number = integerNumber + "." + floatingNumber;
      else number = integerNumber;
      return number;
    },
    numberWithCommas(x) {
      return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    $removeThousand(str) {
      return str.toString().replace(/,/gi, "");
    }
  }
};
